import { useIntercom } from 'react-use-intercom';
import { convertAmount } from "@/utils/currencyResolver"

export default function OrdersPanel({ orders }) {
  const { showNewMessages } = useIntercom()

  const openOrder = (id) => {
    showNewMessages(`I have an order I need help with. Here is my order number ${id}`)
  }


  return (
    <div className="mt-8">
      {orders?.length > 0 ? (
        <div className="flex flex-col">
          <div className="overflow-x-auto">
            <div className="align-middle inline-block min-w-full max-h-[380px]">
              <div className="">
                <div className="overflow-hidden">
                  <table className="min-w-full">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="text-gray-300 px-3 py-3"
                        >
                          #
                        </th>
                        <th
                          scope="col"
                          className="text-gray-300 px-3 py-3 text-center"
                        >
                          Type
                        </th>
                        <th
                          scope="col"
                          className="text-gray-300 px-3 py-3 text-center"
                        >
                          Amount
                        </th>
                        {/* <th
                          scope="col"
                          className="text-gray-300 px-3 py-3 text-center"
                        >
                          Game
                        </th> */}
                        <th
                          scope="col"
                          className="text-gray-300 px-3 py-3 text-right"
                        >
                          RSN
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders
                        .map((order) => (
                          <tr key={order.id} className="even:bg-gray-900 p-4 rounded">
                            <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-300">
                              <button onClick={() => openOrder(order.id)} className="flex underline text-blue-600 hover:text-blue-700">
                                <span className="truncate max-w-[8ch]">{order.id}</span>  
                              </button>
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-300 text-center">{order.type}</td>
                            <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-300 text-center">{convertAmount(order.amount) || '--'}</td>
                            {/* <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-300 text-center">{order.game || '--'}</td> */}
                            <td className="px-3 py-3 whitespace-nowrap text-right text-sm font-medium">{order.rsn}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-8 flex justify-center">You have no active orders.</div>
      )}
    </div>
  )
}